export interface IWishlistItem {
  readonly product_id: number
  readonly color: string
}

export class WishListItem implements IWishlistItem {
  readonly product_id: number
  readonly color: string

  constructor({ product_id, color }: IWishlistItem) {
    this.product_id = product_id
    this.color = color
    return {
      ...this,
    }
  }

  static factEquals(wishListItem1: WishListItem, wishListItem2: WishListItem): boolean {
    return this.getWishListId(wishListItem1) === this.getWishListId(wishListItem2)
  }

  static getWishListId(wishListItem: WishListItem): string {
    return `${wishListItem.product_id}_${wishListItem.color}`
  }
}

export interface SharedWishlistRes {
  user_name?: string
  wishlist?: WishListItem[]
}
